
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type verifyFitmentRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function verifyFitmentRT(): TemplateResult<verifyFitmentRTRootProps> {
    function repeatSelects1(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title',
                                'disabled': true,
                                'key': '12401'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title',
                                'disabled': true,
                                'key': '12404'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('div', {
                        'className': 'option' + (entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3753'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3959'
                    }, entry.hitCount) : null);
                }
                function repeatEntry6(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('div', {
                        'className': 'option' + (entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '4407'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '4609'
                    }, entry.hitCount) : null);
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField7() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_dropdown cm_select_dropdown cm_hide',
                            'key': '2751'
                        },
                        !this.hideNullOption ? _createElement('div', {
                            'className': 'option',
                            'key': 'null-option',
                            'onClick': () => this.onChange('')
                        }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                        this.loading ? _createElement('div', {
                            'className': 'option',
                            'key': 'null-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('div', {
                                'className': 'cm_option_title option',
                                'key': '34411'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry5.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('div', {
                                'className': 'cm_option_title option',
                                'key': '34414'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        !this.loading ? _map(isPopularField ? unpopularEntries : this.entries, repeatEntry6.bind(this, popularEntries, unpopularEntries, isPopularField)) : null
                    ]);
                }
                return _createElement('div', { 'className': this.extraClassName + ' ' + this.extraClassName + '__' + (!this.firstSelectedTerm ? 'empty' : 'selected') }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '177'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'form-input cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField7.apply(this, []) : null);
            }, { count: undefined })];
    }
    function repeatSelects2(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title',
                                'disabled': true,
                                'key': '12401'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title',
                                'disabled': true,
                                'key': '12404'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('div', {
                        'className': 'option' + (entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3753'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3959'
                    }, entry.hitCount) : null);
                }
                function repeatEntry6(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('div', {
                        'className': 'option' + (entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '4407'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '4609'
                    }, entry.hitCount) : null);
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField7() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_dropdown cm_select_dropdown cm_hide',
                            'key': '2751'
                        },
                        !this.hideNullOption ? _createElement('div', {
                            'className': 'option',
                            'key': 'null-option',
                            'onClick': () => this.onChange('')
                        }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                        this.loading ? _createElement('div', {
                            'className': 'option',
                            'key': 'null-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('div', {
                                'className': 'cm_option_title option',
                                'key': '34411'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry5.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('div', {
                                'className': 'cm_option_title option',
                                'key': '34414'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        !this.loading ? _map(isPopularField ? unpopularEntries : this.entries, repeatEntry6.bind(this, popularEntries, unpopularEntries, isPopularField)) : null
                    ]);
                }
                return _createElement('div', { 'className': this.extraClassName + ' ' + this.extraClassName + '__' + (!this.firstSelectedTerm ? 'empty' : 'selected') }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '177'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'form-input cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField7.apply(this, []) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__verify-fitment' }, this.template === 'active' ? _createElement('div', {
        'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
        'key': '68'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, window.Convermax.config?.verifyFitmentTitle || _translate(`verify_fitment_title`)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container ' + (this.isVehicleSelected ? 'cm_vehicle-selected' : '') + ' cmRepeater_selects' },
        _map(this.selects, repeatSelects1.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go button button--primary cm_button-primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, '\n    ', _translate(`ymm_bar_submit`), '\n  '), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear button cm_button-secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button',
        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
    }, '\n    ', _translate(`ymm_bar_clear`), '\n  ')))) : null, this.template === 'locked' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__' + this.fits + ' cmTemplate_locked',
        'key': '8837'
    }, _createElement('div', { 'className': 'cm_verify-fitment_fitment__container' }, _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, this.fits === 'yes' ? [_translate(`verify_fitment_fits`)] : null, this.fits === 'no' ? [_translate(`verify_fitment_does_not_fit`)] : null, this.fits === 'aggressive' ? [_translate(`verify_fitment_aggressive_fits`)] : null, _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-check',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 492 492',
            'key': '95400'
        }, _createElement('path', { 'd': 'm484.13 104.48-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856s-13.964 2.788-19.028 7.856l-226.45 226.45-141.48-141.49c-5.064-5.06-11.82-7.852-19.028-7.852-7.204 0-13.956 2.792-19.024 7.852l-16.12 16.112c-5.068 5.076-7.852 11.836-7.852 19.036 0 7.204 2.784 13.96 7.852 19.028l159.74 159.74c0.212 0.3 0.436 0.58 0.696 0.836l16.12 15.852c5.064 5.048 11.82 7.572 19.084 7.572h0.084c7.212 0 13.968-2.524 19.024-7.572l16.124-15.992c0.26-0.256 0.48-0.468 0.612-0.684l244.78-244.76c10.5-10.476 10.5-27.52 4e-3 -38.008z' }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-times circled',
            'height': '20px',
            'role': 'img',
            'viewBox': '2 2 12 12',
            'key': '102680'
        }, _createElement('path', {
            'style': { stroke: 'none' },
            'd': 'M 8 2 C 4.6862928 2 2 4.6862997 2 8 C 2 11.3137 4.6862928 14 8 14 C 11.313707 14 14 11.3137 14 8 C 14 4.6862997 11.313707 2 8 2 z M 8 3 C 10.761424 3 13 5.2385763 13 8 C 13 9.199635 12.548037 10.263384 11.84375 11.125 L 4.875 4.15625 C 5.7366165 3.4519627 6.8003651 3 8 3 z M 4.15625 4.875 L 11.125 11.84375 C 10.263384 12.548037 9.199635 13 8 13 C 5.2385763 13 3 10.761424 3 8 C 3 6.8003651 3.4519627 5.7366165 4.15625 4.875 z'
        }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-questionmark',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 512 512',
            'key': '108950'
        }, _createElement('path', {
            'd': 'M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324',
            'fill': 'none',
            'stroke': '#000',
            'strokeLinecap': 'round',
            'strokeMiterlimit': '10',
            'strokeWidth': '60'
        }), _createElement('circle', {
            'cx': '248',
            'cy': '399.99',
            'r': '32',
            'fill': '#000'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '114030'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null)), _createElement('div', { 'className': 'cm_verify-fitment_body' }, _createElement('span', { 'className': 'cm_verify-fitment_vehicle' }, _translate(`verify_fitment_vehicle`, {  vehicleString : this. vehicleString  })), _createElement('a', {
        'className': 'cm_verify-fitment_change',
        'onClick': this.changeVehicle
    }, _translate(`ymm_bar_change`))), this.fits === 'no' ? _createElement('div', {
        'className': 'cm_verify-fitment_compatible-parts-container',
        'key': '12906'
    }, _createElement('a', {
        'href': this.getVehicleUrl(),
        'className': 'cm_verify-fitment_compatible-parts'
    }, '\n            ', _translate(`verify_fitment_compatible_parts`), '\n          ')) : null))) : null, this.template === 'inexact' ? _createElement('div', {
        'className': 'cm_vehicle-widget_specifier cmTemplate_inexact',
        'key': '13215'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n      ', _translate(`verify_fitment_specify`, { 
        fieldsToSpecify: this.
        fieldsToSpecify, 
        vehicleString
    : this.
        vehicleString
     }), '\n    '), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container ' + (this.isVehicleSelected ? 'cm_vehicle-selected' : '') + ' cmRepeater_selects' },
        _map(this.selects, repeatSelects2.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button button button--primary button button--primary cm_button-primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, '\n    ', _translate(`ymm_bar_submit`), '\n  ')))) : null, this.template === 'universal' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__universal cmTemplate_universal',
        'key': '21678'
    }, _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, '\n        ', window.Convermax.config?.verifyFitmentUniversalTitle || window.Convermax.config?.fitmentUniversalTitle || _translate(`fitment_universal_title`), '\n        ', _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-check',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 492 492',
            'key': '221240'
        }, _createElement('path', { 'd': 'm484.13 104.48-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856s-13.964 2.788-19.028 7.856l-226.45 226.45-141.48-141.49c-5.064-5.06-11.82-7.852-19.028-7.852-7.204 0-13.956 2.792-19.024 7.852l-16.12 16.112c-5.068 5.076-7.852 11.836-7.852 19.036 0 7.204 2.784 13.96 7.852 19.028l159.74 159.74c0.212 0.3 0.436 0.58 0.696 0.836l16.12 15.852c5.064 5.048 11.82 7.572 19.084 7.572h0.084c7.212 0 13.968-2.524 19.024-7.572l16.124-15.992c0.26-0.256 0.48-0.468 0.612-0.684l244.78-244.76c10.5-10.476 10.5-27.52 4e-3 -38.008z' }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-times circled',
            'height': '20px',
            'role': 'img',
            'viewBox': '2 2 12 12',
            'key': '228520'
        }, _createElement('path', {
            'style': { stroke: 'none' },
            'd': 'M 8 2 C 4.6862928 2 2 4.6862997 2 8 C 2 11.3137 4.6862928 14 8 14 C 11.313707 14 14 11.3137 14 8 C 14 4.6862997 11.313707 2 8 2 z M 8 3 C 10.761424 3 13 5.2385763 13 8 C 13 9.199635 12.548037 10.263384 11.84375 11.125 L 4.875 4.15625 C 5.7366165 3.4519627 6.8003651 3 8 3 z M 4.15625 4.875 L 11.125 11.84375 C 10.263384 12.548037 9.199635 13 8 13 C 5.2385763 13 3 10.761424 3 8 C 3 6.8003651 3.4519627 5.7366165 4.15625 4.875 z'
        }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-questionmark',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 512 512',
            'key': '234790'
        }, _createElement('path', {
            'd': 'M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324',
            'fill': 'none',
            'stroke': '#000',
            'strokeLinecap': 'round',
            'strokeMiterlimit': '10',
            'strokeWidth': '60'
        }), _createElement('circle', {
            'cx': '248',
            'cy': '399.99',
            'r': '32',
            'fill': '#000'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '239870'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null)), _createElement('div', { 'className': 'cm_verify-fitment_notes' }, window.Convermax.config?.verifyFitmentUniversalText || window.Convermax.config?.fitmentUniversalText || _translate(`fitment_universal_text`)))) : null, this.template === 'unknown' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__unknown cmTemplate_unknown',
        'key': '25406'
    }, _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, '\n        ', window.Convermax.config?.fitmentUnknownTitle || _translate(`fitment_unknown_title`), '\n        ', _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-check',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 492 492',
            'key': '257860'
        }, _createElement('path', { 'd': 'm484.13 104.48-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856s-13.964 2.788-19.028 7.856l-226.45 226.45-141.48-141.49c-5.064-5.06-11.82-7.852-19.028-7.852-7.204 0-13.956 2.792-19.024 7.852l-16.12 16.112c-5.068 5.076-7.852 11.836-7.852 19.036 0 7.204 2.784 13.96 7.852 19.028l159.74 159.74c0.212 0.3 0.436 0.58 0.696 0.836l16.12 15.852c5.064 5.048 11.82 7.572 19.084 7.572h0.084c7.212 0 13.968-2.524 19.024-7.572l16.124-15.992c0.26-0.256 0.48-0.468 0.612-0.684l244.78-244.76c10.5-10.476 10.5-27.52 4e-3 -38.008z' }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-times circled',
            'height': '20px',
            'role': 'img',
            'viewBox': '2 2 12 12',
            'key': '265140'
        }, _createElement('path', {
            'style': { stroke: 'none' },
            'd': 'M 8 2 C 4.6862928 2 2 4.6862997 2 8 C 2 11.3137 4.6862928 14 8 14 C 11.313707 14 14 11.3137 14 8 C 14 4.6862997 11.313707 2 8 2 z M 8 3 C 10.761424 3 13 5.2385763 13 8 C 13 9.199635 12.548037 10.263384 11.84375 11.125 L 4.875 4.15625 C 5.7366165 3.4519627 6.8003651 3 8 3 z M 4.15625 4.875 L 11.125 11.84375 C 10.263384 12.548037 9.199635 13 8 13 C 5.2385763 13 3 10.761424 3 8 C 3 6.8003651 3.4519627 5.7366165 4.15625 4.875 z'
        }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-questionmark',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 512 512',
            'key': '271410'
        }, _createElement('path', {
            'd': 'M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324',
            'fill': 'none',
            'stroke': '#000',
            'strokeLinecap': 'round',
            'strokeMiterlimit': '10',
            'strokeWidth': '60'
        }), _createElement('circle', {
            'cx': '248',
            'cy': '399.99',
            'r': '32',
            'fill': '#000'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '276490'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null)), _createElement('div', { 'className': 'cm_verify-fitment_notes' }, window.Convermax.config?.fitmentUnknownText || _translate(`fitment_unknown_text`)))) : null);
}
        export const componentNames = ["cm:filterInput","cm:filterInput"]